export default "__VITE_ASSET__Cl34Jzps__"